import { FormActionDef, FormDefine } from '@/libs/formHelper/form/type'
import { DonationQuery } from '@/api/donation/DonationQuery'

import StoreService from '@/service/StoreService'

export default function getFormDefine (view: any): FormDefine<DonationQuery> {
  const items = [{
    title: '项目名称',
    clearable: true,
    hideLabel: true,
    key: 'nameLk'
  }, {
    title: '村庄',
    type: 'slot',
    slot: 'villageId',
    clearable: true,
    hideLabel: true,
    show: () => StoreService.getTypeSync() === 1,
    key: 'villageId'
  }]

  const actions: FormActionDef<DonationQuery>[] = [{
    key: 'search',
    title: '查询',
    button: 'primary',
    icon: 'ios-search',
    onClick: (_item: DonationQuery) => {
      view.onSearch()
    }
  },
  {
    key: 'add',
    title: '新增',
    icon: 'ios-add',
    onClick: (_item: DonationQuery) => {
      view.onNewItem()
    }
  }]

  return {
    items,
    actions,
    enterTrigger: view.onSearch
  }
}
